<p-sidebar
  #sidebarMenuRef
  [visible]="sidebarVisible()"
  [appendTo]="pageWrapper"
  (onHide)="closeSidebar()"
  styleClass="menu-sidebar">
  <app-menu></app-menu>
</p-sidebar>
<div #pageWrapper class="page-wrapper">
  <div class="page-gradient"></div>
  <app-header class="page-header"></app-header>
  <div class="page-body">
    <router-outlet></router-outlet>
  </div>
  <app-footer class="page-footer"></app-footer>
</div>
